// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "../Utilities/PaymentUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function useIsGuestCustomer() {
  var paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  var customerPaymentMethods = match.customerPaymentMethods;
  return React.useMemo((function () {
                if (typeof paymentMethodList !== "object") {
                  return true;
                }
                if (paymentMethodList.TAG !== "Loaded") {
                  return true;
                }
                var pList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapperFromClientList(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
                var guestCustomerValue = pList.isGuestCustomer;
                if (Core__Option.isNone(guestCustomerValue)) {
                  if (typeof customerPaymentMethods !== "object") {
                    return true;
                  } else if (customerPaymentMethods.TAG === "LoadedSavedCards") {
                    if (customerPaymentMethods._1) {
                      return true;
                    } else {
                      return false;
                    }
                  } else if (customerPaymentMethods._0) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  return Core__Option.getOr(guestCustomerValue, true);
                }
              }), [
              paymentMethodList,
              customerPaymentMethods
            ]);
}

function useHandlePostMessages(complete, empty, paymentType, savedMethodOpt) {
  var savedMethod = savedMethodOpt !== undefined ? savedMethodOpt : false;
  var loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  var iframeId = match.iframeId;
  React.useEffect((function () {
          Utils$OrcaPaymentPage.handlePostMessageEvents(iframeId, complete, empty, paymentType, loggerState, savedMethod);
        }), [
        complete,
        empty,
        paymentType,
        savedMethod
      ]);
}

function useIsCustomerAcceptanceRequired(displaySavedPaymentMethodsCheckbox, isSaveCardsChecked, isGuestCustomer) {
  var paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  return React.useMemo((function () {
                if (displaySavedPaymentMethodsCheckbox) {
                  if (isSaveCardsChecked) {
                    return true;
                  } else {
                    return paymentMethodListValue.payment_type === "SETUP_MANDATE";
                  }
                } else {
                  return !(isGuestCustomer || paymentMethodListValue.payment_type === "NORMAL");
                }
              }), [
              isSaveCardsChecked,
              paymentMethodListValue.payment_type,
              isGuestCustomer,
              displaySavedPaymentMethodsCheckbox
            ]);
}

function useSendEventsToParent(eventsToSendToParent) {
  React.useEffect((function () {
          var handle = function (ev) {
            var eventDataObject = ev.data;
            var eventsDict = Utils$OrcaPaymentPage.getDictFromJson(eventDataObject);
            var events = Object.keys(eventsDict);
            var shouldSendToParent = events.some(function ($$event) {
                  return eventsToSendToParent.includes($$event);
                });
            if (shouldSendToParent) {
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, Object.entries(eventsDict));
            }
            
          };
          window.addEventListener("message", handle);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
}

function useUpdateRedirectionFlags() {
  var setRedirectionFlags = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  return function (paymentOptions) {
    var topRedirection = Core__Option.flatMap(paymentOptions["shouldUseTopRedirection"], Core__JSON.Decode.bool);
    var removeBeforeUnloadEvents = Core__Option.flatMap(paymentOptions["shouldRemoveBeforeUnloadEvents"], Core__JSON.Decode.bool);
    setRedirectionFlags(function (cv) {
          return {
                  shouldUseTopRedirection: Core__Option.getOr(topRedirection, cv.shouldUseTopRedirection),
                  shouldRemoveBeforeUnloadEvents: Core__Option.getOr(removeBeforeUnloadEvents, cv.shouldRemoveBeforeUnloadEvents)
                };
        });
  };
}

export {
  useIsGuestCustomer ,
  useHandlePostMessages ,
  useIsCustomerAcceptanceRequired ,
  useSendEventsToParent ,
  useUpdateRedirectionFlags ,
}
/* jotai Not a pure module */
